// ZPL export - S47.3a / S48.1.
// Genera un string ZPL para impresoras Zebra usando comandos NATIVOS.
// 203 DPI fijo (8 dots/mm). QR/Code128 nativos: ^BQN/^BCN.
//
// S48.1: acepta `bundle` para resolver bindKeys de tipo bundle.* (DEMO).
import { findSize } from '../utils';
import { valueForField } from '../dynamicFields';

const DOTS_PER_MM = 8;

function _mm(mm) { return Math.max(0, Math.round(Number(mm || 0) * DOTS_PER_MM)); }

function _esc(value) {
  return String(value == null ? '' : value)
    .replace(/\^/g, ' ')
    .replace(/~/g, ' ')
    .replace(/\\/g, ' ');
}

function _zplText(f, value) {
  const x = _mm(f.xMm);
  const y = _mm(f.yMm);
  const h = _mm(f.hMm);
  const w = Math.max(8, Math.round(h * 0.6));
  return '^FO' + x + ',' + y + '^A0N,' + h + ',' + w + '^FD' + _esc(value) + '^FS';
}

function _zplQr(f, value) {
  const x = _mm(f.xMm);
  const y = _mm(f.yMm);
  const sideMm = Math.min(Number(f.wMm || 0), Number(f.hMm || 0));
  let mag = Math.round(sideMm / 4);
  if (mag < 1) mag = 1;
  if (mag > 10) mag = 10;
  return '^FO' + x + ',' + y + '^BQN,2,' + mag + '^FDLA,' + _esc(value) + '^FS';
}

function _zplBarcode(f, value) {
  const x = _mm(f.xMm);
  const y = _mm(f.yMm);
  const h = _mm(f.hMm);
  return '^BY2,3,' + h + '^FO' + x + ',' + y + '^BCN,' + h + ',Y,N,N^FD' + _esc(value) + '^FS';
}

function _zplField(f, producto, bundle) {
  if (!f) return '';
  const value = valueForField(f, producto, bundle);
  if (f.type === 'qr') return _zplQr(f, value);
  if (f.type === 'barcode') return _zplBarcode(f, value);
  return _zplText(f, value);
}

export function renderEtiquetaZpl(state, producto, bundle) {
  if (!state || typeof state !== 'object') return '';
  const sz = findSize(state.sizeId);
  const fields = Array.isArray(state.fields) ? state.fields : [];
  const lines = [];
  lines.push('^XA');
  lines.push('^PW' + _mm(sz.wMm));
  lines.push('^LL' + _mm(sz.hMm));
  lines.push('^LH0,0');
  for (let i = 0; i < fields.length; i += 1) {
    const z = _zplField(fields[i], producto, bundle);
    if (z) lines.push(z);
  }
  lines.push('^XZ');
  return lines.join('\n');
}

function _safeName(s) {
  return String(s || '').replace(/[^A-Za-z0-9_-]+/g, '-').replace(/^-+|-+$/g, '');
}

function _suffix(producto, bundle) {
  if (bundle && bundle.code) return '-' + _safeName(bundle.code);
  if (producto && (producto.sku || producto.codigo)) {
    return '-' + _safeName(producto.sku || producto.codigo);
  }
  return '';
}

export function downloadEtiquetaZpl(state, producto, bundle) {
  const zpl = renderEtiquetaZpl(state, producto, bundle);
  if (!zpl) return false;
  if (typeof document === 'undefined') return false;
  const blob = new Blob([zpl], { type: 'text/plain;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const sizeBit = _safeName((state && state.sizeId) || 'etiqueta');
  const a = document.createElement('a');
  a.href = url;
  a.download = 'etiqueta-' + sizeBit + _suffix(producto, bundle) + '.zpl';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  return true;
}
